import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import axiosInstance from '../../axiosConfig';
import '../../styles/Profile.css';
import { Circles } from 'react-loader-spinner';
import Notification from '../notification/Notification';

const Profile = () => {
    const { auth, login } = useContext(AuthContext);
    const [email, setEmail] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [notification, setNotification] = useState(null);
    const [loading, setLoading] = useState(false); // State to manage loading

    useEffect(() => {
        if (auth) {
            fetchUserProfile();
        }
    }, [auth]);

    const fetchUserProfile = async () => {
        setLoading(true); // Set loading to true when starting the fetch
        try {
            const response = await axiosInstance.get('/api/profile');
            if (response.data && response.data.email) {
                setEmail(response.data.email);
            } else {
                throw new Error('Email not found in response');
            }
        } catch (error) {
           // console.error('Error fetching user profile:', error);
            setNotification({ message: 'Failed to load profile. Please try again later.', isError: true });
        } finally {
            setLoading(false); // Set loading to false once fetching is complete
        }
    };

    const handleInputChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSave = async () => {
        if (!validateEmail(email)) {
            setNotification({ message: 'Please enter a valid email address.', isError: true });
            return;
        }

        setLoading(true); // Set loading to true when the save process starts

        try {
            const response = await axiosInstance.put('/api/profile', { email });

            // Update the context with the new email
            login({ ...auth, email: response.data.email }, auth.accessToken, auth.refreshToken);
            localStorage.setItem('auth', JSON.stringify({ ...auth, email: response.data.email }));

            setNotification({ message: 'Profile updated successfully!', isError: false });
            setIsEditing(false);
        } catch (error) {
           // console.error('Error updating profile:', error);
            setNotification({ message: 'Error updating profile. This email is already in use.', isError: true });
        } finally {
            setLoading(false); // Set loading to false once the save process is complete
        }
    };

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    return (
        <div className="profile-container">
            <h2>Profile</h2>
            {notification && (
                <Notification
                    message={notification.message}
                    isError={notification.isError}
                    onClose={() => setNotification(null)}
                />
            )}
            <div className="profile-details">
                <label>Email:</label>
                <input
                    type="email"
                    name="email"
                    value={loading ? '' : email} // Clear value when loading
                    onChange={handleInputChange}
                    placeholder={loading ? 'Loading email...' : 'Enter your email'} // Placeholder text
                    disabled={!isEditing || loading} // Disable input when not editing or loading
                />
                {isEditing ? (
                    <div className="profile-actions">
                        <button onClick={handleSave} disabled={loading}>
                            {loading ? (
                                <Circles
                                    height="20"
                                    width="20"
                                    color="#36454F"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                />
                            ) : (
                                'Save'
                            )}
                        </button>
                        <button onClick={() => setIsEditing(false)} disabled={loading}>
                            Cancel
                        </button>
                    </div>
                ) : (
                    <button onClick={() => setIsEditing(true)} disabled={loading}>
                        Edit Profile
                    </button>
                )}
            </div>
        </div>
    );
};

export default Profile;
